import { InputTextDesignTokens } from "@primeuix/themes/types/inputtext";
import { primitiveColorTokens, primitiveLayoutTokens } from "src/assets/layout/styles/tokens/primitive";

export const inputtext: InputTextDesignTokens = {
    root: {
        borderRadius: primitiveLayoutTokens.borderRadius,
        placeholderColor: primitiveColorTokens.shade[400],
    },
    css: () => {
        return `
        .p-inputtext {
            &.ng-invalid.ng-dirty {
                border-color: #ef4444;
            }

            &:focus {
                box-shadow: 0 0 0 0.2rem rgba(239, 68, 68, 0.25);
            }

            &:disabled {
                cursor: not-allowed;
                opacity: 0.6;
            }
        }

        .p-inputgroup {
            .p-inputgroup-addon {
                background-color: var(--p-azara-shade-100);
                border-color: var(--p-azara-shade-300);
                color: var(--p-azara-shade-700);
            }
        }
        `;
    },
};
